import React from "react";
/** 将JSON.stringify(props.data)作为子组件的key，
 * 在props.data的内容变化后让Component重新初始化
 * @author 张卓诚
 */
export function rerenderHoc(Component) {
    return React.memo((props) => {
        return React.createElement(Component, Object.assign({ key: JSON.stringify(props.data) }, Object.assign({}, props)));
    });
}
//# sourceMappingURL=rerender-hoc.js.map